function initUpload() {
    $('.inputfile').filestyle({
        buttonText: '<i class="icon-upload"></i><span>Uploaden</span>',
        placeholder: 'Upload hier je CV'
    });
}

function initScrollError() {
    if ($('.error.msg').length > 0) {
        $('html,body').scrollTop($("#apply-form").offset().top - 30);
    }
}

function initValidation() {
    $("#sollicitatie").validate({
            messages: {
                firstname: "Vul een geldige voornaam in",
                lastname: "Vul een geldige achternaam in",
                woonplaats: "Vul een geldig woonplaats in",
                address: "Vul een geldig adres in",
                email: "Vul een geldig emailadres in",
                phone: "Vul een geldig telefoonnummer in",
                motivation: "Vul een motivatie in",
            },
            submitHandler: function (form) {
                var recaptchaElement = document.querySelector('.g-recaptcha');
                if (recaptchaElement) {
                    grecaptcha.execute();
                }
            }
        }
    );
}
